export default __webpack_public_path__ + "images/slide_1.jpg?b502fe13dde5653ad2e32a4370ec4a7c";